import React from 'react';
import cx from 'classnames';

const ToggleButton = ({ checked, handleChecked, onText = 'on', offText = 'off', className }) => {
    return (
        <label className={cx('pnt-toggle', className)}>
            <input type="checkbox" checked={checked} onClick={handleChecked} />
            <span className="slider"></span>
            <p>{offText}</p>
            <p>{onText}</p>
            <div className="icon-toggle-type icon-lock off"></div>
            <div className="icon-toggle-type icon-lock"></div>
        </label>
    );
};

export default ToggleButton;
